import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import Swal from 'sweetalert2';
import { MessageService } from '../services/message.service.js';
import { AuthContextService } from '../services/auth-context.service.js';
import { environment } from '../../environments/environment';
@Component({
    selector: 'app-feedback-popup',
    imports: [FormsModule],
    templateUrl: './feedback-popup.component.html',
    styleUrl: './feedback-popup.component.scss'
})
export class FeedbackPopupComponent {
  isPopupActive = false;
  selectedOption = 'Suggestion';
  feedbackText = '';
  private http = inject(HttpClient);
  private messageService = inject(MessageService);
  private authContext = inject(AuthContextService);

  openPopup() {
    this.isPopupActive = true;
  }

  closePopup() {
    this.isPopupActive = false;
  }

  submitFeedback() {
  
    
 if (!this.feedbackText.trim()) {
  this.messageService.showFeedbackMissing();
  return;
}

	    const payload = {
	      user_id: this.authContext.getEmail() || this.authContext.getUserId(),
      type: this.selectedOption,
      description: this.feedbackText,
      db_name: "v2"
    };

    this.http.post(`${environment.apiBaseUrl}/feedback`, payload)
    .subscribe({
  next: (response) => {    // First close the popup
    this.closePopup();
    // Then show the success message
    this.messageService.showFeedbackSuccess().then((result) => {
      // Reset form after user dismisses the alert
      this.feedbackText = '';
      this.selectedOption = 'Suggestion';
    });
  },
  error: (error) => {    this.messageService.showFeedbackError();
  }
});
  }

  resetForm() {
    this.feedbackText = '';
    this.selectedOption = 'Suggestion';
    this.closePopup();
  }

  selectOption(option: string) {
    this.selectedOption = option;
  }
}
